import { ITypedOptionList } from "./option-list";
import { TypedOptionListBase } from "./option-list-base";
import { OptionListType } from "./option-list-type";
import { IHierarchicalOptionListValue } from "./option-list-value";

export type IHierarchicalOptionList = ITypedOptionList<IHierarchicalOptionListValue>;

export default class HierarchicalOptionList
    extends TypedOptionListBase<IHierarchicalOptionListValue>
    implements IHierarchicalOptionList
{
    readonly type: OptionListType = OptionListType.Hierarchical;
}

export { HierarchicalOptionList };
